export default __webpack_public_path__ + "static/media/mongodbLogo.0781b723.svg";